
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 70"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1"}},[_c('path',{attrs:{"fill":"#9e9e9e","d":"M53.8 1.1l-1.6-1c-.1-.1-.3-.1-.4 0L29.2 13.2l-.7-.8c0-.1-.1-.1-.2-.1l-1.6-.9c-.2-.1-.4-.1-.7.1L7.2 22.4c-.3.2-.7.6-.8 1l-1.7 4-4.1 2.4c-.3.2-.6.6-.6 1l.1 37c0 .2.1.3.2.4l1.6.9c-.1-.1 51.9-68 51.9-68z"}}),_c('path',{attrs:{"fill":"#e5e4e4","d":"M53.3 1.1c.3-.2.6 0 .6.3l.1 37c0 .4-.3.8-.6 1L2.3 68.9c-.3.2-.6 0-.6-.3l-.1-37c0-.4.3-.8.6-1l4.1-2.4 1.7-4c.2-.4.5-.8.8-1l18.8-10.9c.3-.2.7-.2.8.1l1.7 2.1L53.3 1.1z"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#9C948D","d":"M7.1 30.6h.1l1 .6s.1 0 0 .3l-1 1.7s0 .2-.3.2l-.1-.1s-.1 0 0-.3l.4-.8-1 .6c-.1.1-.2 0-.2-.1v-.2c0-.1.1-.3.2-.3l1-.6-.4-.2s-.1 0 0-.3l.1-.2c.2-.2.2-.2.2-.3zM4.1 32.4h.1l.1.1s.1 0 0 .3l-.4.8 1-.6c.1-.1.2 0 .2.1v.2c0 .1-.1.3-.2.3l-1 .6.4.3s.1 0 0 .3l-.1.2s0 .2-.3.2l-1-.6s-.1 0 0-.3l1-1.7.2-.2z"}}),_c('path',{attrs:{"fill":"#fff","d":"M51.1 4.2c.2-.1.3 0 .3.2v4c0 .2-.1.4-.3.5L9.9 32.7c-.2.1-.3 0-.3-.2v-4c0-.2.1-.4.3-.5L51.1 4.2z"}}),_c('path',{attrs:{"fill":"#80b6bf","d":"M52.8 9.8l.1 28.8L2.8 67.5l-.1-28.7z"}}),_c('path',{staticClass:"st5",attrs:{"fill":"#FFE24B","d":"M28.5 46.5c-3.9 2.2-7.2.4-7.2-4 0-4.5 3.1-10 7.1-12.3 3.9-2.2 7.2-.4 7.2 4 0 4.5-3.1 10-7.1 12.3m0-17.6c-4.5 2.6-8.1 8.9-8.1 14s3.7 7.2 8.1 4.7c4.5-2.6 8.1-8.9 8.1-14s-3.7-7.2-8.1-4.7"}}),_c('path',{staticClass:"st5",attrs:{"fill":"#FFE24B","d":"M25.7 35.7v8.9l7-8.5z"}})])])
          )
        }
      }
    